import React from "react";
import { useFormik } from "formik";
import { ChequeAddFormValidation } from "./ChequeAdvancedSearchValidation";
import { Box } from "@material-ui/core";
import { withRouter } from "react-router";
import checkDateInput from "../../../utility/CheckDateInput/checkDateInput";
import ChequeAdvancedSearchFormFields from "./ChequeAdvancedSearchFormFields";

const validationSchema = ChequeAddFormValidation;

const ChequeAdvancedSearchForm = (props) => {
  let valueDefault = {
    cheque_id: "",
    icis: "",
    id: "",

    giver_user_id: "",
    giver_user_fullname: "",
    reciver_user_id: "",
    reciver_user_fullname: "",
    first_party_id: "",
    first_party_fullname: "",
    second_party_id: "",
    second_party_fullname: "",

    amount: null,

    due_date: null,
    due_date_start: null,
    due_date_end: null,
    recieverable_type: "",
    recieverable_id: "",
    recieverable_name: "",
  };

  if (props.isEdit || props.isRepeat) {
    valueDefault = {
      ...valueDefault,
      ...props.data,
      is_guarantee_cheque: props.data.is_guarantee_cheque == "1",
    };
  }

  const formikData = useFormik({
    initialValues: valueDefault,
    validationSchema: validationSchema,
    onSubmit: (values, actions) => {
      let newValue = values;
      try {
        newValue.due_date = values.due_date
          ? checkDateInput(values.due_date)
          : null;
        newValue.due_date_start = values.due_date_start
          ? checkDateInput(values.due_date_start)
          : null;
        newValue.due_date_end = values.due_date_end
          ? checkDateInput(values.due_date_end)
          : null;
      } catch (e) {
        console.log(e);
      }
      newValue.id = parseInt(newValue.id)
      if (newValue.recieverable_type === "انتخاب کنید") {
        newValue.recieverable_type = "";
      }

      submitHandle(values);
    },
  });

  const submitHandle = (values) => {
    props.updateSearch(values);
  };

  const [loading, setLoading] = React.useState(false);

  // formikData.isSubmitting = false;
  return (
    <Box>
      <ChequeAdvancedSearchFormFields
        isEdit={props.isEdit}
        loading={loading}
        {...formikData}
      />
    </Box>
  );
};

export default withRouter(ChequeAdvancedSearchForm);
